import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { SidebarIdProjectSettings } from '@jira/navigation-apps__constants/src/SidebarIdProjectSettings.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { projectSettingsSoftwareIssuetypesRoute } from '@jira/router-routes__project-settings-product-routes-software-routes/src/projectSettingsSoftwareIssuetypesRoute.tsx';
import { softwareProjectLayout } from '@jira/platform__layouts-software-project-layout/src/index.tsx';
import type { Route } from '@atlassian/react-resource-router';
import { getUFOName } from './ui/index.tsx';
import IssueTypePage, { LazyIssueTypeSettings } from './ui/project-settings/issue-type/index.tsx';
import { getSettingsNavigationResources } from './ui/project-settings/product-routes/common/index.tsx';

export const projectSettingsSoftwareIssuetypesRouteEntry: Route = createEntry(
	projectSettingsSoftwareIssuetypesRoute,
	() => ({
		group: 'project-settings-software',
		ufoName: getUFOName('project-settings-software-issuetypes'),
		// eslint-disable-next-line no-restricted-syntax
		component: IssueTypePage,
		layout: softwareProjectLayout,

		navigation: {
			menuId: MenuIdProjects,
			sidebarId: SidebarIdProjectSettings,
		},

		resources: [...getSettingsNavigationResources()],
		forPaint: [LazyAtlassianNavigation, LazyIssueTypeSettings],

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
